/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceAppRpc
 */

export const getComponentStatusForPortalRpc = {
  serviceName: 'com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceAppRpc',
  rpcName: 'getComponentStatusForPortal',
  auth: 'app',
  fingerprint: 'zxaKI_kDF_ToUzkoOIKVZq1YvUGsL_jy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};